import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { OfferProtocol } from '../mutations/useUploadOfferProtocol'

export const offerProtocolsQueryKey = ['offer-protocols']

export function useOfferProtocols(offerId: string | undefined) {
  async function getProtocols() {
    const response = await apiClient.get<OfferProtocol[]>(
      `${SNA_PREFIX}offers/${offerId}/protocols/`
    )

    return response.data
  }

  return useQuery({
    queryFn: getProtocols,
    enabled: !!offerId,
    queryKey: [...offerProtocolsQueryKey, offerId]
  })
}
